import { BuyerRequisites } from "../../components/buyer-requisites";
import { PageTemplate } from "../../components/page-template"

export const BuyerSettingsPage = () => {
    const navItems = [
        { label: 'предложения', to: '/', active: false },
        { label: 'пункты приема', to: '/buyer-points', active: false },
    ];
    return (
        <PageTemplate navItems={navItems}>
            <BuyerRequisites/>
        </PageTemplate>
    )
}